
import isLocationInList from '../helpers/Restrictions/Geolocation';
import { uniformDomain } from '../helpers/utils';

export const States = {
  Pending: 'Pending',
  Verifying: 'Verifying',
  Verified: 'Verified',
  Blocked: 'Blocked',
};

export const BlockingReason = {
  Active: 'Active',
  Date: 'Date',
  Domain: 'Domain',
  Location: 'Location',
};

export const BlockingDisplayType = {    // REVIEW TODO expandir con mas tipos de displays para las diferentes razones, incluyendo customizacion por parte del cliente
  Image: 'Image',
  Countdown: 'Countdown',
}

const fastObjects = {   // NOTE para uso local, reduce redundancia
  emptyVerified: {
    state: States.Verified,
    blockedOptions: {},
  },
  reasonableImageBlocked: reason => ({
    state: States.Blocked,
    blockedOptions: {
      blockingReason: reason,
      blockingDisplayType: BlockingDisplayType.Image,
    },
  }),
};

const Restrictions = {

  processConfiguration: loadedConfiguration => {
    const playbackRestrictions = {
      iframeIsActive: (loadedConfiguration.active && loadedConfiguration.active !== '0' && true) || false,
      publishDate: loadedConfiguration.publishDate,
      unpublishDate: loadedConfiguration.unpublishDate,
      shouldVerifyDomain: false,
      shouldVerifyLocation: false,
    };

    if( loadedConfiguration.secureDomains && loadedConfiguration.secureDomains.length > 0) {
      playbackRestrictions.shouldVerifyDomain = true;
      playbackRestrictions.whitelistedDomains = loadedConfiguration.secureDomains;    // REVIEW considerar indexar lista en forma de objeto, para optimizar busquedas
    }

    if( loadedConfiguration.geoblocking && loadedConfiguration.geoblocking.length > 0) {
      playbackRestrictions.shouldVerifyLocation = true;
      playbackRestrictions.blacklistedLocations = loadedConfiguration.geoblocking;    // REVIEW considerar indexar lista en forma de objeto, para optimizar busquedas
    }
  
    return playbackRestrictions;
  },

  verifyActive: iframeIsActive => {
    if( iframeIsActive) return fastObjects.emptyVerified;
    else return fastObjects.reasonableImageBlocked( BlockingReason.Active);
  },

  verifyDate: (publishDate, unpublishDate) => {
    const now = Date.now();
    if( publishDate) publishDate = new Date( publishDate);
    if( unpublishDate) unpublishDate = new Date( unpublishDate);
    if( publishDate && publishDate > 0 && publishDate > now) return {
      state: States.Blocked,
      blockedOptions: {
        blockingReason: BlockingReason.Date,
        blockingDisplayType: BlockingDisplayType.Countdown,
        blockedUntil: publishDate,
      },
    };
    if( unpublishDate && unpublishDate > 0 && unpublishDate < now) return fastObjects.reasonableImageBlocked( BlockingReason.Date);
    return fastObjects.emptyVerified;
  },

  verifyDomain: whitelistedDomains => {   // REVIEW considerar usar un metodo react puro que no dependa de window
    let topDomain;
    if( window.top.location !== window.location) {    // NOTE normalmente los navegadores consideran acceder a window.top un acceso crossdomain y esta protegido por cors, esta comprobacion se considera una excepcion especial
      topDomain = uniformDomain( document.referrer);    // REVIEW considerar usar window.top.document.domain u otra variante que pueda diferenciar players embebidos de referenciados; IMPORTANTE tener en cuenta que esto requeriria abrir CORS desde el lado del cliente
    } else {
      topDomain = uniformDomain( document.domain);
    }
    if( topDomain === '') return fastObjects.reasonableImageBlocked( BlockingReason.Domain);
    for( let domain of whitelistedDomains) {
      if( topDomain === uniformDomain( domain)) return fastObjects.emptyVerified;
    }
    return fastObjects.reasonableImageBlocked( BlockingReason.Domain);
  },

  verifyLocation: async( blacklistedLocations) => {
    if( await isLocationInList( blacklistedLocations)) {
      return fastObjects.reasonableImageBlocked( BlockingReason.Location);
    } else return fastObjects.emptyVerified;
  },

  verify: async( playbackRestrictions, verifiedRestrictionsCallback) => {
    try {
      let state, blockedOptions;

      if( state !== States.Blocked) {
        ({ state, blockedOptions } = Restrictions.verifyActive( playbackRestrictions.iframeIsActive) );
      }
      if( state !== States.Blocked) {
        ({ state, blockedOptions } = Restrictions.verifyDate( playbackRestrictions.publishDate, playbackRestrictions.unpublishDate) );
      }
      if( state !== States.Blocked && playbackRestrictions.shouldVerifyDomain) {
        ({ state, blockedOptions } = Restrictions.verifyDomain( playbackRestrictions.whitelistedDomains) );
      }
      if( state !== States.Blocked && playbackRestrictions.shouldVerifyLocation) {
        ({ state, blockedOptions } = await Restrictions.verifyLocation( playbackRestrictions.blacklistedLocations) );
      }

      if( verifiedRestrictionsCallback) verifiedRestrictionsCallback( { state, blockedOptions }, null);
    } catch( error) {
      const newError = { message: 'Error verificando las reestricciones.', baseError: error };
      if( verifiedRestrictionsCallback) verifiedRestrictionsCallback( {}, newError);
    }
  },

};

export default Restrictions;

